import React, { Component, Fragment } from 'react';
import {
    EditorState, EditorBlock, Modifier, SelectionState,
} from 'draft-js';
import Prism from 'prismjs';

/*
 * SYNTAX HIGHLIGHTING FOR CODE BLOCKS
 *
 * Below is a list of languages that can be chosen for syntax highlighting.
 * The Object key always refers to the package name; all available packages
 * can be found in node_modules/prismjs/components/. You must also include
 * that language in the .babelrc definition.
 */

const languages = {
    applescript: 'Applescript',
    bash: 'Bash',
    c: 'C',
    clojure: 'Clojure',
    cpp: 'C++',
    csharp: 'C Sharp',
    css: 'CSS',
    elm: 'Elm',
    go: 'Go',
    graphql: 'GraphQl',
    haskell: 'Haskell',
    java: 'Java',
    javascript: 'JavaScript',
    json: 'JSON',
    jsx: 'JSX',
    latex: 'Latex',
    lisp: 'Lisp',
    markdown: 'Markdown',
    markup: 'HTML',
    perl: 'Perl',
    php: 'PHP',
    python: 'Python',
    r: 'R',
    reason: 'Reason',
    ruby: 'Ruby',
    scala: 'Scala',
    sql: 'SQL',
    swift: 'Swift',
    'visual-basic': 'Visual Basic',
};

class LanguageSwitcher extends Component {
    shouldComponentUpdate(nextProps, nextState) {
        return nextProps.blockProps.language !== this.props.blockProps.language;
    }

    onSelect = (e) => {
        e.stopPropagation();
    };

    selectLang = (event) => {
        const { editorState, setEditorState } = this.props.blockProps;
        const blockSelection = SelectionState.createEmpty(this.props.block.getKey());

        setEditorState(
            EditorState.push(
                editorState,
                Modifier.setBlockData(
                    editorState.getCurrentContent(),
                    blockSelection,
                    { language: event.target.value },
                ),
            ),
        );
    };

    render() {
        const { language } = this.props.blockProps;

        const value = language;
        const label = languages[value] || 'Auto';

        return (
            <div onInput={e => e.stopPropagation()}>
                <div
                    className="code-lang-switcher"
                    contentEditable={false}
                >
                    <label htmlFor="language-select">
                        {label}
                        <span className="dropdown-carat" />
                    </label>
                    <select
                        name="language-select"
                        value={value}
                        onChange={this.selectLang}
                    >
                        <option key="auto" value={undefined}>Auto</option>
                        {Object.keys(languages).map((lang, index) => (
                            <option key={lang} value={lang}>{languages[lang]}</option>
                        ))}
                    </select>
                </div>
            </div>
        );
    }
}

class Code extends React.PureComponent {
    render() {
        const selectedLang = languages[this.props.blockProps.language] || '';
        return (
            <div>
                <EditorBlock {...this.props} />
                {!this.props.blockProps.readOnly
                    ? <LanguageSwitcher key="language-switcher" {...this.props} />
                    : (<div className="code-lang-switcher"><span>{selectedLang}</span></div>)}
            </div>
        );
    }
}

export default Code;
